export const ROLES = Object.freeze({
  INVESTOR: 'Investor',
  MANAGER: 'Manager',
  ADMIN: 'Admin',
  MURABAHA_REPRESENTATIVE: 'Murabaha Representative',
});

export type RoleTypesKey = keyof typeof ROLES;
export type RoleTypesValue = (typeof ROLES)[RoleTypesKey];

/** Enum for Role Types Based on Group ID from Database */
export enum RoleType {
  ADMIN = 1,
  INVESTOR = 2,
  MANAGER = 3,
  MURABAHA_REPRESENTATIVE = 4,
}
